import { _, moment } from "../../vendor";
import InboomaBaseView from "./InboomaBaseView";

import AccessBarTpl from "../templates/AccessBarTpl.html";

export default InboomaBaseView.extend({
  options: {
    activeLink: "default",
    pageTitle: "",
    searchPlaceholder: "",
    linksMap: {},
  },

  el: "#inb-c-main-access-bar",
  template: AccessBarTpl,

  ui: {
    searchField: "#inb-c-main-access-bar__search .inb-input--search",
    changeViewType: ".inb-hor-icon-nav",
    closeSearchField: ".inb-search-close",
  },

  events: {
    "keyup @ui.searchField": "_filterQuery",
    "click @ui.closeSearchField": "resetSearch",
  },

  templateContext() {
    let searchValue = "";

    if (this.collection && typeof this.collection.getFiltersWithValue === "function") {
      const activeFilters = this.collection.getFiltersWithValue();

      if (typeof activeFilters["q"] !== "undefined") {
        searchValue = activeFilters["q"];
      }
      if (typeof activeFilters["query"] !== "undefined") {
        searchValue = activeFilters["query"];
      } else if (typeof activeFilters["order_nbr"] !== "undefined") {
        searchValue = activeFilters["order_nbr"];
      }
    }

    return {
      _,
      collection: this.getOption("collection"),
      options: this.options,
      searchValue,
    };
  },

  changeActiveLink(activeLink) {
    // Called by e.g. router
    this.options.activeLink = activeLink;
    this.render();
  },

  initialize() {
    this.render();
    this.queryState = {
      timeStamp: 0,
      value: "",
    };
  },

  resetSearch() {
    this.getUI("searchField")[0].value = "";
    this._filterQuery();
  },

  _filterQuery() {
    // @todo For better performance, delay triggering of
    // collection.filterByQuery to use latest actual value
    console.log("YEPP, collection: ", this);
    const query = this.getUI("searchField")[0].value.toLowerCase();

    const collection = this.collection;
    const minLength = this.options.activeLink == "users" ? 3 : 2;

    if (query.length >= minLength) {
      this._setUnsetButton(true);

      const that = this;
      setTimeout(function () {
        var diff = Number(moment().format("x")) - that.queryState.timeStamp;
        if (diff > 700 && that.queryState.value == query) {
          // no changes after the last 700 ms -> user finished input -> start request
          collection.filterByQuery(query); // -> this avoids additional requests during typing
        }
      }, 800);
    } else if (query.length < minLength) {
      this._setUnsetButton(false);

      if (typeof collection.restoreInactiveFilter == "function") {
        collection.restoreInactiveFilter();
      } else {
        collection.removeFilter("query");
        collection.removeFilter("q");
        collection.removeFilter("order_nbr");
      }

      if (typeof collection._superset !== "undefined") {
        if (typeof collection._superset._filterParams !== "undefined") {
          delete collection._superset._filterParams["q"];
        }
      }
    }
    // update query state
    this.queryState.timeStamp = Number(moment().format("x"));
    this.queryState.value = query;
  },

  /**
   * Toggle visibility of close search btn
   */
  _setUnsetButton(visible) {
    this.getUI("closeSearchField").toggleClass("hide", !visible);
  },
});
